import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import { Button } from '@material-ui/core';
import { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import Filter from '../../../../Filters/Filter';
import { SearchModes, SearchStatus } from '../../../../../constants';
import { getHotelRateCodeKeysRequest } from '../../../../../store/slices/hotel';
import MarkdownToHtml from '../../../../MarkdownToHtml';

const RateCodeKeys = ({
  filterSpacingClass,
  icon,
  variant,
  label,
  dropdownAligning,
  selectedSearchMode,
  fontWeight,
  className,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const isConfirmation = router.pathname.indexOf('confirmation') > -1;
  const [showDropDown, setShowDropDown] = useState(true);
  const { hotelRateDescription, hotelRateCodeKeysLoadingStatus } = useSelector(
    (store) => store.hotel,
  );

  useEffect(() => {
    if (
      selectedSearchMode === SearchModes.HOTEL &&
      !isConfirmation &&
      !hotelRateDescription &&
      hotelRateCodeKeysLoadingStatus !== SearchStatus.SEARCHING &&
      hotelRateCodeKeysLoadingStatus !== SearchStatus.DONE
    ) {
      dispatch(getHotelRateCodeKeysRequest({ hotelRateDescription }));
    }
  }, [
    dispatch,
    isConfirmation,
    hotelRateCodeKeysLoadingStatus,
    hotelRateDescription,
    selectedSearchMode,
  ]);

  const handleButtonClick = (event) => {
    event.stopPropagation();
    setShowDropDown(false);
  };

  const handleDivClick = () => {
    setShowDropDown(true);
  };

  const handleDivKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setShowDropDown(true);
    }
  };

  const RateCodeKey = useMemo(
    () =>
      !hotelRateDescription ? (
        <></>
      ) : (
        <div className="max-w-lg mx-auto bg-white pl-4 pt-2 pb-1 rounded-lg top-0 sticky text-black">
          <div className="bg-white z-10 pb-2 border-b-2 border-gray-300 sticky top-0">
            <div className="font-semibold flex justify-between items-center ">
              Rate Code Key
              <Button className="w-10 h-8 bg-red-500 text-opacity-40" onClick={handleButtonClick}>
                <FaTimes color="gray" size={18} />
              </Button>
            </div>
            <p className="mb-1">{hotelRateDescription.headerDescription}</p>
          </div>
          <MarkdownToHtml content={hotelRateDescription.description} className="mt-2 text-black" />
        </div>
      ),
    [hotelRateDescription],
  );

  return !isConfirmation && selectedSearchMode === SearchModes.HOTEL && hotelRateDescription ? (
    <div
      role="button"
      tabIndex={-1}
      onClick={handleDivClick}
      onKeyDown={handleDivKeyDown}
      className={className}
    >
      <Filter
        label={label}
        menuWidthClass="w-max"
        variant={variant}
        filterMaxWidthClass="max-w-full"
        withClear={false}
        filterSpacingClass={filterSpacingClass}
        isFilterEmpty
        showChevronArrows={false}
        icon={icon}
        fontSize={`text-base ${fontWeight}`}
        dropdownAligning={dropdownAligning}
      >
        {showDropDown ? RateCodeKey : <></>}
      </Filter>
    </div>
  ) : (
    <></>
  );
};

RateCodeKeys.propTypes = {
  filterSpacingClass: PropTypes.string,
  icon: PropTypes.node,
  variant: PropTypes.string,
  label: PropTypes.string,
  dropdownAligning: PropTypes.string,
  selectedSearchMode: PropTypes.oneOf(Object.values(SearchModes)).isRequired,
  fontWeight: PropTypes.string,
  className: PropTypes.string,
};

RateCodeKeys.defaultProps = {
  filterSpacingClass: 'py-2 px-3',
  icon: undefined,
  variant: 'outline',
  label: 'Show Rate Code Key',
  dropdownAligning: 'left',
  fontWeight: 'font-medium',
  className: '',
};

export default RateCodeKeys;
